import { Alert, Grid, Paper, Stack, Typography } from '@mui/material';

import { DateTime } from '@common/utils/datetime';
import { AccessRequestClientModel, useGetUserSession } from '@apono/client-app-sdk';
import { Status } from '@common/ui/Status';
import LabeledData from '@common/ui/LabeledData';

const severityByStatus: Record<string, 'success' | 'info' | 'warning' | 'error'> = {
  pending: 'info',
  approved: 'info',
  rejected: 'error',
  granted: 'success',
  revoking: 'warning',
  expired: 'warning',
  failed: 'error',
};

export default function RequestOverview({ request }: { request: AccessRequestClientModel }) {
  const { data: userSession } = useGetUserSession();
  return (
    <div>
      {request.status.description && (
        <Alert
          variant="outlined"
          sx={{ marginBottom: 2 }}
          severity={severityByStatus[request.status.status.toLowerCase()]}
        >
          <Typography variant="caption">{request.status.description}</Typography>
        </Alert>
      )}
      <Stack spacing={1}>
        <Typography variant="subtitle2">Overview:</Typography>
        <Paper variant="details">
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <LabeledData label="Created" value={DateTime.fromUnix(Number(request.creation_time)).readable} />
            </Grid>
            <Grid item xs={6}>
              <LabeledData label="Status" value={<Status status={request.status.status} />} />
            </Grid>
            {userSession?.settings.request_custom_fields?.map((customField) => {
              const value = request.custom_fields?.[customField.id];
              if (!value) return null;
              return (
                <Grid item xs={6} key={customField.id}>
                  <LabeledData label={customField.label} value={value} />
                </Grid>
              );
            })}
            {request.bundle && (
              <Grid item xs={6}>
                <LabeledData label="Bundle" value={request.bundle.name} />
              </Grid>
            )}
            <Grid item xs={6}>
              <LabeledData label="Justification" value={request.justification} />
            </Grid>
          </Grid>
        </Paper>
      </Stack>
    </div>
  );
}
